// import React, { useState } from 'react';
// import './loginstyle.css';
// import Navbar from '../../Components/Navbar';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons';
// import RoleOption from './RoleOption';
// import ForgetPassword from './Forgotpassword';
// import { URL } from '../../config';
// import { useNavigate } from 'react-router-dom';

// const Login = () => {
//     const navigate = useNavigate();
//     const [email, setEmail] = useState('');
//     const [password, setPassword] = useState('');
//     const [errMsg, setErrMsg] = useState('');

//     const [selectedRole, setSelectedRole] = useState('user');
//     const [showRolePopup, setShowRolePopup] = useState(false);
//     const [showForgotPasswordPopup, setShowForgotPasswordPopup] = useState(false);

//     const handleRoleSelection = (role) => {
//         setSelectedRole(role);
//         setShowRolePopup(false);
//     };

//     const toggleRolePopup = () => {
//         setShowRolePopup(!showRolePopup);
//     };

//     const toggleForgotPasswordPopup = () => {
//         setShowForgotPasswordPopup(!showForgotPasswordPopup);
//     };

//     const loginHandleBtn = async (e) => {
//         e.preventDefault();
//         try {
//             const response = await fetch(`${URL}/login`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify({ email, password, role: selectedRole })
//             });

//             if (response.ok) {
//                 const { token } = await response.json();
//                 localStorage.setItem('token', token);
//                 console.log('User successfully logged in. Token:', token);
                
//                 if (selectedRole === 'admin') {
//                     navigate("/admin/dashboard");
//                 } else if (selectedRole === 'servitor') {
//                     navigate("/servitor");
//                 } else {
//                     navigate("/home");
//                 }
                
//             } else {
//                 const error = await response.json();
//                 setErrMsg(error.error);
//                 console.log('User not valid');
//             }
//         } catch (error) {
//             console.error('Error during login:', error);
//             setErrMsg('Failed to connect to server');
//         }
//     };

//     return (
//         <>
//             <Navbar />
//             <div className="login-container">
//                 <div className="left-section">
//                     <h1>HelpNao</h1>
//                     <h5>HelpNao connects service seekers with qualified providers, simplifying your life for a hassle-free experience.</h5>
//                 </div>
//                 <div className="right-section">
//                     <div className='login-header'>
//                         <h2 className='text'>Log in</h2>
//                         <div className='underline'></div>
//                     </div>
//                     <form onSubmit={loginHandleBtn}>
//                         <div className='login-form'>
//                             <div className="form-group input-container">
//                                 <FontAwesomeIcon className='icon' icon={faEnvelope} />
//                                 <input type="email" id="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email address" />
//                             </div>
//                             <div className="form-group input-container">
//                                 <FontAwesomeIcon className='icon' icon={faLock} />
//                                 <input type="password" id="password" name="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" />
//                             </div>
//                             <div className='checkbox-group-container'>
//                                 <div className="checkbox-group">
//                                     <label className="checkbox-label" htmlFor="admin">
//                                         <input type="checkbox" id="admin" name="role" value="admin" checked={selectedRole === 'admin'} onChange={() => handleRoleSelection('admin')} />
//                                         Admin
//                                     </label>
//                                     <label className="checkbox-label" htmlFor="user">
//                                         <input type="checkbox" id="user" name="role" value="user" checked={selectedRole === 'user'} onChange={() => handleRoleSelection('user')} />
//                                         User
//                                     </label>
//                                     <label className="checkbox-label" htmlFor="servitor">
//                                         <input type="checkbox" id="servitor" name="role" value="servitor" checked={selectedRole === 'servitor'} onChange={() => handleRoleSelection('servitor')} />
//                                         Servitor
//                                     </label>
//                                 </div>
//                             </div>
//                         </div>
//                         {errMsg && <div className="error-message">{errMsg}</div>}
//                         <button className="login-btn" type="submit">Enter</button>
//                         <div className='spantag'>
//                             <span className="forgot-password-link" onClick={toggleForgotPasswordPopup}>Forget password?</span>
//                         </div>
//                         <hr />
//                         <button className="create-btn" type="button" onClick={toggleRolePopup}>Create Account</button>
//                     </form>
//                 </div>
//             </div>
//             {showRolePopup && <RoleOption onClose={() => setShowRolePopup(false)} onSelectRole={handleRoleSelection} />}
//             {showForgotPasswordPopup && <ForgetPassword onClose={() => setShowForgotPasswordPopup(false)} />}
//         </>
//     );
// };

// export default Login;

// *** Upper Login code all is working fine and perfect - last checked (18-6-25) *** //





// ***** Translate added EN-BN - (18-6-25) ***** //

// import React, { useState } from "react";
// import "./loginstyle.css";
// import Navbar from "../../Components/Navbar";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faEnvelope, faLock } from "@fortawesome/free-solid-svg-icons";
// import RoleOption from "./RoleOption";
// import ForgetPassword from "./Forgotpassword";
// import { URL } from "../../config";
// import { useNavigate } from "react-router-dom";

// import { useTranslation } from "react-i18next";

// const Login = () => {
//   const { t, i18n } = useTranslation();

//   const navigate = useNavigate();
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [errMsg, setErrMsg] = useState("");

//   const [selectedRole, setSelectedRole] = useState("user");
//   const [showRolePopup, setShowRolePopup] = useState(false);
//   const [showForgotPasswordPopup, setShowForgotPasswordPopup] = useState(false);

//   const handleRoleSelection = (role) => {
//     setSelectedRole(role);
//     setShowRolePopup(false);
//   };

//   const toggleRolePopup = () => {
//     setShowRolePopup(!showRolePopup);
//   };

//   const toggleForgotPasswordPopup = () => {
//     setShowForgotPasswordPopup(!showForgotPasswordPopup);
//   };

//   const loginHandleBtn = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch(`${URL}/login`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ email, password, role: selectedRole }),
//       });

//       if (response.ok) {
//         const { token } = await response.json();
//         localStorage.setItem("token", token);
//         console.log("User successfully logged in. Token:", token);

//         if (selectedRole === "admin") {
//           navigate("/admin/dashboard");
//         } else if (selectedRole === "servitor") {
//           navigate("/servitor");
//         } else {
//           navigate("/home");
//         }
//       } else {
//         const error = await response.json();

//         // setErrMsg(error.error);
//         // console.log('User not valid');

//         const errorMessage = error.error || "Internal server error";
//         const errorKey = errorMessage.toLowerCase().replace(/\s+/g, "_");
//         const translatedError =
//           i18n.language === "bn"
//             ? t(`login.error_messages.${errorKey}`, {
//                 defaultValue: errorMessage,
//               })
//             : errorMessage;
//         setErrMsg(translatedError);
//         console.log("Login error:", errorMessage);
//       }
//     } catch (error) {
//       console.error("Error during login:", error);

//       // setErrMsg('Failed to connect to server');
//       setErrMsg(t("login.error_messages.internal_server_error"));
//     }
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="login-container">
//         <div className="left-section">
//           {/* <h1>HelpNao</h1> */}
//           <h1 dangerouslySetInnerHTML={{ __html: t("login.logo") }} />
//           {/* <h5>HelpNao connects service seekers with qualified providers, simplifying your life for a hassle-free experience.</h5> */}
//           <h5>{t("login.description")}</h5>
//         </div>
//         <div className="right-section">
//           <div className="login-header">
//             <h2 className="text">{t("login.header")}</h2>

//             <div className="underline"></div>
//           </div>
//           <form onSubmit={loginHandleBtn}>
//             <div className="login-form">
//               <div className="form-group input-container">
//                 <FontAwesomeIcon className="icon" icon={faEnvelope} />
//                 <input
//                   type="email"
//                   id="email"
//                   name="email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   placeholder={t("login.email_placeholder")}
//                 />
//               </div>
//               <div className="form-group input-container">
//                 <FontAwesomeIcon className="icon" icon={faLock} />
//                 <input
//                   type="password"
//                   id="password"
//                   name="password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   placeholder={t("login.password_placeholder")}
//                 />
//               </div>
//               <div className="checkbox-group-container">
//                 <div className="checkbox-group">
//                   {/* <label className="checkbox-label" htmlFor="admin">
//                     <input
//                       type="checkbox"
//                       id="admin"
//                       name="role"
//                       value="admin"
//                       checked={selectedRole === "admin"}
//                       onChange={() => handleRoleSelection("admin")}
//                     />
//                     // Admin
//                     {t("login.admin_label")}
//                   </label> */}

//                   <label className="checkbox-label" htmlFor="user">
//                     <input
//                       type="checkbox"
//                       id="user"
//                       name="role"
//                       value="user"
//                       checked={selectedRole === "user"}
//                       onChange={() => handleRoleSelection("user")}
//                     />
//                     {/* User */}
//                     {t("login.user_label")}
//                   </label>
//                   <label className="checkbox-label" htmlFor="servitor">
//                     <input
//                       type="checkbox"
//                       id="servitor"
//                       name="role"
//                       value="servitor"
//                       checked={selectedRole === "servitor"}
//                       onChange={() => handleRoleSelection("servitor")}
//                     />
//                     {/* Servitor */}
//                     {t("login.servitor_label")}
//                   </label>
//                 </div>
//               </div>
//             </div>
//             {errMsg && <div className="error-message">{errMsg}</div>}
//             <button className="login-btn" type="submit">
//               {/* Enter */}
//               {t("login.enter_button")}
//             </button>
//             <div className="spantag">
//               <span
//                 className="forgot-password-link"
//                 onClick={toggleForgotPasswordPopup}
//               >
//                 {/* Forget password? */}
//                 {t("login.forgot_password")}
//               </span>
//             </div>
//             <hr />
//             <button
//               className="create-btn"
//               type="button"
//               onClick={toggleRolePopup}
//             >
//               {/* Create Account */}
//               {t("login.create_account")}
//             </button>
//           </form>
//         </div>
//       </div>
//       {showRolePopup && (
//         <RoleOption
//           onClose={() => setShowRolePopup(false)}
//           onSelectRole={handleRoleSelection}
//         />
//       )}
//       {showForgotPasswordPopup && (
//         <ForgetPassword onClose={() => setShowForgotPasswordPopup(false)} />
//       )}
//     </>
//   );
// };

// export default Login;



// ***** Upper all code is okay and working (24-7-2025) ***** //




// ***** new update with design (24-7-2025) ***** //




import React, { useState, useEffect } from "react";
import "./loginstyle.css";
import Navbar from "../../Components/Navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faLock, faSpinner, faEye, faEyeSlash  } from "@fortawesome/free-solid-svg-icons";
import RoleOption from "./RoleOption";
import SignUpForm   from "./Signup";
import ServitorSignup from "./ServitorSignup";
import ForgetPassword from "./Forgotpassword";
import { URL } from "../../config";
import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";

const Login = () => {
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [errMsg, setErrMsg] = useState("");

  // const [selectedRole, setSelectedRole] = useState("user");
  const [loginRole, setLoginRole] = useState("user");
  const [showRolePopup, setShowRolePopup] = useState(false);
  const [showForgotPasswordPopup, setShowForgotPasswordPopup] = useState(false);

  const [showSignup,    setShowSignup]    = useState(false);
  const [signupRole,    setSignupRole]    = useState(null);

  const [showPassword, setShowPassword] = useState(false);


  // const handleRoleSelection = (role) => {
  //   // setSelectedRole(role);
  //   // setShowRolePopup(false);
  // };

  const toggleRolePopup = () => {
    setShowRolePopup(!showRolePopup);
  };

  const toggleForgotPasswordPopup = () => {
    setShowForgotPasswordPopup(!showForgotPasswordPopup);
  };


   // 🔒 If already logged in, don't show login page
  useEffect(() => {
    const token = localStorage.getItem("token");
    const rawRole = localStorage.getItem("role") || "";
    const role = rawRole.trim().toLowerCase();

    if (token && role) {
      if (role === "admin") {
        navigate("/admin/dashboard", { replace: true });
      } else if (role === "servitor") {
        navigate("/servitor", { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    }
  }, [navigate]);


  const loginHandleBtn = async (e) => {
    e.preventDefault();
    if (isSubmitting) return; // guard against double-clicks
    try {
      setIsSubmitting(true);
      const response = await fetch(`${URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        // body: JSON.stringify({ email, password, role: loginRole }),
        body: JSON.stringify({ mobile, password, role: loginRole }),
      });

      if (response.ok) {
        const { token } = await response.json();
        //  Clear any previous auth state
        localStorage.removeItem("token");
        localStorage.removeItem("adminToken");
        localStorage.removeItem("adminInfo");
        localStorage.removeItem("role");
        sessionStorage.clear();

        localStorage.setItem("token", token);

        // New added for protect route
        localStorage.setItem("role", loginRole.toLowerCase());

        // console.log("User successfully logged in. Token:", token);

        // 👉 Auto-set language based on role
        if (loginRole === "servitor") {
          // Default servitor UI to Bangla
          if (i18n.language !== "bn") {
            i18n.changeLanguage("bn");
          }
        } else {
          // Optional: make normal users/admin default to English
          if (i18n.language !== "en") {
            i18n.changeLanguage("en");
          }
        }

        // if (loginRole  === "admin") {
        //   navigate("/admin/dashboard");
        // } else if (loginRole  === "servitor") {
        //   navigate("/servitor");
        // } else {
        //   navigate("/home");
        // }
        if (loginRole === "admin") {
          navigate("/admin/dashboard", { replace: true });
        } else if (loginRole === "servitor") {
          navigate("/servitor", { replace: true });
        } else {
          navigate("/", { replace: true });
        }

      } else {
        const error = await response.json();

        // setErrMsg(error.error);
        // console.log('User not valid');

        const errorMessage = error.error || "Internal server error";
        const errorKey = errorMessage.toLowerCase().replace(/\s+/g, "_");
        const translatedError =
          i18n.language === "bn"
            ? t(`login.error_messages.${errorKey}`, {
                defaultValue: errorMessage,
              })
            : errorMessage;
        setErrMsg(translatedError);
        console.log("Login error:", errorMessage);
      }
    } catch (error) {
      console.error("Error during login:", error);

      // setErrMsg('Failed to connect to server');
      setErrMsg(t("login.error_messages.internal_server_error"));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="login-container">
        <div className="left-section">
          {/* <h1>HelpNao</h1> */}
          <h1 dangerouslySetInnerHTML={{ __html: t("login.logo") }} />
          {/* <h5>HelpNao connects service seekers with qualified providers, simplifying your life for a hassle-free experience.</h5> */}
          <h5>{t("login.description")}</h5>
        </div>
        <div className="right-section">
          <div className="login-header">
            <h2 className="text">{t("login.header")}</h2>

            <div className="underline"></div>
          </div>
          <form onSubmit={loginHandleBtn}>
            <div className="login-form">
              <div className="form-group input-container">
                {/* <FontAwesomeIcon className="icon" icon={faEnvelope} />
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t("login.email_placeholder")}
                /> */}

                <FontAwesomeIcon className="icon" icon={faPhone} />
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  inputMode="numeric"
                  pattern="[0-9]{11}"
                  maxLength={11}
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value.replace(/\D/g, "").slice(0, 11))}
                  placeholder={t("login.mobile_placeholder") || "01XXXXXXXXX"}
                  required
                  disabled={isSubmitting}
                />
              </div>
              <div className="form-group input-container">
                <FontAwesomeIcon className="icon" icon={faLock} />
                <input
                  // type="password"
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder={t("login.password_placeholder")}
                  disabled={isSubmitting}
                  autoComplete="current-password"
                  required
                />
                {/* For view password */}
                <button
                  type="button"
                  className="password-toggle-btn"
                  onClick={() => setShowPassword((s) => !s)}
                  disabled={isSubmitting}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  aria-pressed={showPassword}
                  tabIndex={0}
                >
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </button>
              </div>
              <div className="checkbox-group-container">
                <div className="checkbox-group">
                  {/* <label className="checkbox-label" htmlFor="admin">
                    <input
                      type="checkbox"
                      id="admin"
                      name="role"
                      value="admin"
                      checked={selectedRole === "admin"}
                      onChange={() => handleRoleSelection("admin")}
                    />
                    // Admin
                    {t("login.admin_label")}
                  </label> */}

                  <label className="checkbox-label" htmlFor="user">
                    <input
                      type="checkbox"
                      id="user"
                      name="role"
                      value="user"
                      // checked={selectedRole === "user"}
                      // onChange={() => handleRoleSelection("user")}
                      checked={loginRole === "user"}
                      // onChange={() => setLoginRole("user")}
                      onChange={() => !isSubmitting && setLoginRole("user")}
                      disabled={isSubmitting}
                    />
                    {/* User */}
                    {t("login.user_label")}
                  </label>
                  <label className="checkbox-label" htmlFor="servitor">
                    <input
                      type="checkbox"
                      id="servitor"
                      name="role"
                      value="servitor"
                      // checked={selectedRole === "servitor"}
                      // onChange={() => handleRoleSelection("servitor")}
                      checked={loginRole === "servitor"}
                      // onChange={() => setLoginRole("servitor")}
                      onChange={() => !isSubmitting && setLoginRole("servitor")}
                      disabled={isSubmitting}
                    />
                    {/* Servitor */}
                    {t("login.servitor_label")}
                  </label>
                </div>
              </div>
            </div>
            {errMsg && <div className="error-message">{errMsg}</div>}
            {/* <button className="login-btn" type="submit">
              {t("login.enter_button")}
            </button> */}

            <button
              className={`login-btn ${isSubmitting ? "is-loading" : ""}`}
              type="submit"
              disabled={isSubmitting}
              aria-busy={isSubmitting}
              aria-live="polite"
            >
              {isSubmitting ? (
                <>
                  <FontAwesomeIcon icon={faSpinner} spin className="btn-spinner" />
                  <span className="btn-text">
                    {t("login.logging_in", "Logging in…")}
                  </span>
                </>
              ) : (
                <span className="btn-text">{t("login.enter_button")}</span>
              )}
            </button>

            <div className="spantag">
              <span
                className="forgot-password-link"
                onClick={toggleForgotPasswordPopup}
                aria-disabled={isSubmitting}
                style={isSubmitting ? { pointerEvents: "none", opacity: 0.6 } : undefined}
              >
                {/* Forget password? */}
                {t("login.forgot_password")}
              </span>
            </div>
            <hr />
            <button
              className="create-btn"
              type="button"
              // onClick={toggleRolePopup}
              onClick={isSubmitting ? undefined : toggleRolePopup}
              disabled={isSubmitting}
              aria-disabled={isSubmitting}
            >
              {/* Create Account */}
              {t("login.create_account")}
            </button>
          </form>
        </div>
      </div>
      {/* {showRolePopup && (
        <RoleOption
          onClose={() => setShowRolePopup(false)}
          onSelectRole={handleRoleSelection}
        />
      )} */}

      {showRolePopup && (
       <RoleOption
         onClose={() => setShowRolePopup(false)}
         onSelectRole={(role) => {
           setShowRolePopup(false);   // hide the picker
           setSignupRole(role);       // remember which form
           setShowSignup(true);       // show the signup overlay
         }}
       />
     )}

    {showSignup && signupRole === "user" && (
      <SignUpForm onClose={() => setShowSignup(false)} />
    )}
    {showSignup && signupRole === "servitor" && (
      <ServitorSignup onClose={() => setShowSignup(false)} />
    )}

      {showForgotPasswordPopup && (
        <ForgetPassword onClose={() => setShowForgotPasswordPopup(false)} />
      )}
    </>
  );
};

export default Login;